import React from 'react';
import Link from './Link/Link';
import { ROUTE_HOME } from '@/src/constants/routes';

const GoToHomeLink = () => <Link to={ROUTE_HOME}>Go to the homepage</Link>;

export default GoToHomeLink;
